import { Button } from '@mui/material';
import { Box, Typography } from '..';
import { useNotification } from 'hooks';

export interface Props {
  children: string;
}

const CopyToClipboardButton = ({ children }: Props) => {
  const { notifySuccess } = useNotification();

  const handleClick = () => {
    notifySuccess('Copied to clipboard');
    navigator.clipboard.writeText(children);
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      sx={{ border: 1, borderRadius: 1, borderColor: 'primary.main' }}
      width="100%"
      alignItems="center"
    >
      <Typography ml={1}>{children}</Typography>
      <Button onClick={handleClick}>Copy</Button>
    </Box>
  );
};

export default CopyToClipboardButton;
